import { updateDraftApi as generatedUpdateDraftApi } from '../generated/quickDraft/updateDraft';

const updateDraftApi = generatedUpdateDraftApi.enhanceEndpoints({
  endpoints: {
    updateDraft: {
      invalidatesTags: (result, _error, { id }) => {
        const date = result?.draft?.date;

        if (!date) {
          return [{ id, type: 'Drafts' as const }];
        }

        return [
          { id, type: 'Drafts' as const },
          { id: date, type: 'Drafts' as const },
          { id: date, type: 'Slots' as const },
        ];
      },
    },
  },
});

export const { useUpdateDraftMutation } = updateDraftApi;
